export const MIN_CHAR_LEVEL = 1;
export const MAX_CHAR_LEVEL = 713;

export const MIN_STAT_LEVEL = 0;
export const MAX_STAT_LEVEL = 99;